import { render } from "./MbaHealth.vue?vue&type=template&id=d9bb5e9a"
import script from "./MbaHealth.vue?vue&type=script&lang=js"
export * from "./MbaHealth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__